import YGGDRASILSLOTActions from './YGGDRASILSLOTActions'

export default class YGGDRASILTABLEActions extends YGGDRASILSLOTActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      platform: 'YGGDRASIL',
      gameType: 'TABLE',
      gameCode: 'YGG-TABLE-001',
    }

    this.gameName = 'Golden Chip Roulette'
  }
}
